<template>
    <div class="solution-detail">
        <div>
            <img style="width: 100%" src="../assets/images/v2_s3sqsj.jpg" alt="">
        </div>
        <div class="solution-main">
            <div class="solution-list">
                <el-menu
                        default-active="2"
                        class="el-menu-vertical-demo"
                        @open="handleOpen"
                        @close="handleClose"
                >
                    <el-sub-menu index="1">
                        <template #title>
                            <el-icon><location /></el-icon>
                            <span>智慧城市集成</span>
                        </template>
                        <el-sub-menu index="1-1">
                            <template #title>
                                <el-icon><location /></el-icon>
                                <span>集成解决方案</span>
                            </template>
<!--                            <el-menu-item-group title="新测绘">-->
<!--                                <el-menu-item index="1-1-1">空天遥感监测</el-menu-item>-->
<!--                                <el-menu-item index="1-1-2">航空摄影测量</el-menu-item>-->
<!--                                <el-menu-item index="1-1-3">地表测绘调查</el-menu-item>-->
<!--                                <el-menu-item index="1-1-4">地下水下探测</el-menu-item>-->
<!--                            </el-menu-item-group>-->
<!--                            <el-menu-item-group title="行业信息化">-->
<!--                                <el-menu-item index="1-1-5">智慧自然资源</el-menu-item>-->
<!--                                <el-menu-item index="1-1-6">智慧规划</el-menu-item>-->
<!--                                <el-menu-item index="1-1-7">智慧住建</el-menu-item>-->
<!--                                <el-menu-item index="1-1-8">智慧农业农村</el-menu-item>-->
<!--                            </el-menu-item-group>-->
                        </el-sub-menu>

                        <el-sub-menu index="1-2">
                            <template #title>
                                <el-icon><location /></el-icon>
                                <span>行业解决方案</span>
                            </template>
                            <el-menu-item-group title="新测绘">
                                <el-menu-item index="1-2-1">空天遥感监测</el-menu-item>
                                <el-menu-item index="1-2-2">航空摄影测量</el-menu-item>
                                <el-menu-item index="1-2-3">地表测绘调查</el-menu-item>
                                <el-menu-item index="1-2-4">地下水下探测</el-menu-item>
                            </el-menu-item-group>
                            <el-menu-item-group title="行业信息化">
                                <el-menu-item index="1-2-5">智慧自然资源</el-menu-item>
                                <el-menu-item index="1-2-6">智慧规划</el-menu-item>
                                <el-menu-item index="1-2-7">智慧住建</el-menu-item>
                                <el-menu-item index="1-2-8">智慧农业农村</el-menu-item>
                            </el-menu-item-group>
                        </el-sub-menu>

                    </el-sub-menu>
                </el-menu>
            </div>
            <div class="solution-info">
                <div class="solution-info-header">
                    <el-icon style="margin-right: 10px;"><location /></el-icon>
                    <el-breadcrumb :separator-icon="ArrowRight" style="display: inline-block">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item>智慧+典型案例</el-breadcrumb-item>
                        <el-breadcrumb-item>智慧城市集成</el-breadcrumb-item>
                        <el-breadcrumb-item>行业解决方案</el-breadcrumb-item>
                        <el-breadcrumb-item>济南高新区城市管理智慧化平台项目</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="solution-info-text">
                    <div class="title">济南高新区城市管理智慧化平台项目</div>
                    <div class="text">
                        作为国家级十大高新区之一，济南高新区全面落实国家关于智慧城市的建设要求，探索大部制改革后智慧应用。通过建设具大部制特色的城市管理智慧化平台集成了国土空间规划、自然资源、住房城乡建设、城市管理等方面的智慧化应用，实现了高新区全域全信息汇聚、全周期监管、全流程服务、全要素治理与智能化决策。开展多领域、多场景的实战应用，打造"高新区样本"，为数字化业务赋能。
                    </div>
                    <div class="sub-title">数据融合，实现一库信息汇聚</div>
                    <div class="text">
                        平台已对接全市范围城市规划、建设、管理等领域业务系统31个，汇聚自然资源、国土空间规划、住房城乡建设、城市管理、市政交通、园林绿化等数据要素230余个，建成现状类、规划类、自然资源类、执法类、建设类、城管类、规划管理类数据库共7个，形成城市管理大数据中心，构建城市数据资源体系，推进数据跨部门、跨层级汇聚融合和深度利用，夯实城市数字底座。
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import {ArrowRight} from "@element-plus/icons-vue";

export default {
  name: "SolutionDetail",
  computed: {
    ArrowRight() {
      return ArrowRight
    }
  }
}
</script>

<style scoped>
.solution-detail {
    width: 100%;
    .solution-main {
        width: 100%;
        height: 1000px;
        display: flex;
        flex-direction: row;
        padding: 20px 0px;
        .solution-list {
            position: relative;
            width: 300px;
            height: 100%;
        }
        .solution-info {
            border-left: 1px solid gray;
            position: relative;
            text-align: left;
            /*background-color: red;*/
            flex: 1;
            height: 100%;
            .solution-info-header {
                padding: 20px;
            }
        }
        .solution-info-text {
            padding: 15px 30px;
            .title {
                text-align: center;
                font-size: 30px;
                font-weight: bold;
                padding: 20px 0;
            }
            .sub-title {
                font-size: 25px;
                font-weight: bold;
                padding: 20px 0;
            }
            .text {
                text-indent: 2em;
                font-size: 20px;
                padding: 20px 0;
            }
        }
    }
}
</style>